import type { FieldArrayWithId } from 'react-hook-form';

import type { OrderFormValues } from '../ui/order-form';

export function getTotalPrice(
  fields: FieldArrayWithId<OrderFormValues, 'items', 'id'>[]
): number {
  return fields.reduce(
    (sum, field) =>
      !Number.isNaN(+field.price) ? sum + +field.price * +field.quantity : sum,
    0
  );
}
